const { VITE_REACT_APP_SHA: REACT_APP_SHA } = import.meta.env

const REACT_APP_SHA_LENGTH = 8

const RELEASE_NOTES_URL =
  'https://mijnaansluiting.atlassian.net/wiki/spaces/Wiki/pages/40271873/Release+notes+CAPO'

const getVersion = (): string =>
  REACT_APP_SHA ? '-' + REACT_APP_SHA.substring(0, REACT_APP_SHA_LENGTH) : ''

export { getVersion, RELEASE_NOTES_URL }
